import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Spin } from 'antd';
import { useAuth } from '../../auth/AuthProvider';
import { AuthCard } from '../../components/AuthCard';
import { errorMessage } from '../../api/client';

export function LoginPage() {
  const { status, needsSetup, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (status === 'loading') return <div className="auth-screen"><Spin size="large" /></div>;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  if (needsSetup) return <Navigate to="/register" replace />;

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.email, values.password);
      navigate((location.state as { from?: string } | null)?.from ?? '/', { replace: true });
    } catch (e) {
      setError(errorMessage(e, 'Login failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Sign in" subtitle="Welcome back. Sign in to your workspace.">
      {error && <Alert type="error" title={error} style={{ marginBottom: 16 }} showIcon />}
      <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
          <Input autoComplete="email" autoFocus />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }]}>
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={loading}>
          Sign in
        </Button>
      </Form>
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <Link to="/forgot-password">Forgot your password?</Link>
      </div>
    </AuthCard>
  );
}
